export default [
    {
        path: "/training/speed-march/list",
        component: () => import("@/App/Training/SpeedMarch/Components/List.vue"),
        name: "training-speed-march-list",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/speed-march/create",
        component: () => import("@/App/Training/SpeedMarch/Components/Create.vue"),
        name: "training-speed-march-create",
        meta: {
            requiresAuth: true,
        },
    },
];
